export const COOKIE_SAVE_ID = 'saveId'
export const COOKIE_AUTO_LOGIN = 'autoLogin'